import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4276ab24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-screen h-screen" }
const _hoisted_2 = { class: "h-screen flex items-center justify-center" }
const _hoisted_3 = { class: "educationModal fixed mb-10" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between h-full"
}
const _hoisted_5 = { class: "imgHolder h-full" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "rightSide" }
const _hoisted_8 = { class: "school font-bold" }
const _hoisted_9 = { class: "major font-semibold" }
const _hoisted_10 = { class: "setting font-medium" }
const _hoisted_11 = { class: "flex justify-start" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "academics font-bold mt-6" }, " ACADEMICS ", -1))
const _hoisted_14 = { class: "academicsBox font-normal" }
const _hoisted_15 = { class: "academicsList" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "academics font-bold mt-6" }
const _hoisted_18 = { class: "academicsBox font-normal" }
const _hoisted_19 = { class: "academicsList" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "academics font-bold mt-6" }, " HONORS ", -1))
const _hoisted_22 = { class: "academicsBox font-normal" }
const _hoisted_23 = { class: "academicsList" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 0,
  class: "academics font-bold mt-6"
}
const _hoisted_26 = { class: "academicsBox font-normal pb-3" }
const _hoisted_27 = { class: "academicsList" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 1,
  class: "h-full"
}
const _hoisted_30 = { class: "imgHolder h-full" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "rightSide h-full relative" }
const _hoisted_33 = { class: "school font-bold" }
const _hoisted_34 = { class: "major font-semibold" }
const _hoisted_35 = { class: "setting font-medium" }
const _hoisted_36 = { class: "flex justify-start" }
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "academics font-bold mt-6" }, " ACADEMICS ", -1))
const _hoisted_39 = { class: "academicsBox font-normal" }
const _hoisted_40 = { class: "academicsList" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "academics font-bold mt-6" }
const _hoisted_43 = { class: "academicsBox font-normal" }
const _hoisted_44 = { class: "academicsList" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "academics font-bold mt-6" }, " HONORS ", -1))
const _hoisted_47 = { class: "academicsBox font-normal" }
const _hoisted_48 = { class: "academicsList" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = {
  key: 0,
  class: "academics font-bold mt-6"
}
const _hoisted_51 = { class: "academicsBox font-normal pb-5" }
const _hoisted_52 = { class: "academicsList" }
const _hoisted_53 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
      class: "shadow bg-black w-screen h-screen z-50 absolute left-0 top-0 opacity-90"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.screen == 'computer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                  class: "exit font-light absolute top-6 right-6"
                }, " x "),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    class: "object-cover h-full",
                    src: _ctx.info.image
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.info.school), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.info.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.info.location) + "   |   " + _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_12)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_13,
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.academics, (academic) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: academic }, null, 8, _hoisted_16))
                      }), 256))
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.info.school === 'University of Nebraska-Lincoln' ? 'INVOLVEMENTS' : 'ACTIVITIES'), 1),
                  _createElementVNode("p", _hoisted_18, [
                    _createElementVNode("ul", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.activities, (activity) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: activity }, null, 8, _hoisted_20))
                      }), 256))
                    ])
                  ]),
                  _hoisted_21,
                  _createElementVNode("p", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.honors, (honor) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: honor }, null, 8, _hoisted_24))
                      }), 256))
                    ])
                  ]),
                  (_ctx.info.coursework.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, " RELEVANT COURSEWORK "))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_26, [
                    _createElementVNode("ul", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.coursework, (course) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: course }, null, 8, _hoisted_28))
                      }), 256))
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    class: "object-cover w-full h-full",
                    src: _ctx.info.image
                  }, null, 8, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                    class: "exit font-light absolute top-4 right-3"
                  }, " x "),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.info.school), 1),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.info.title), 1),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.info.location) + "   |   " + _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_37)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_38,
                  _createElementVNode("p", _hoisted_39, [
                    _createElementVNode("ul", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.academics, (academic) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: academic }, null, 8, _hoisted_41))
                      }), 256))
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.info.school === 'University of Nebraska-Lincoln' ? 'INVOLVEMENTS' : 'ACTIVITIES'), 1),
                  _createElementVNode("p", _hoisted_43, [
                    _createElementVNode("ul", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.activities, (activity) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: activity }, null, 8, _hoisted_45))
                      }), 256))
                    ])
                  ]),
                  _hoisted_46,
                  _createElementVNode("p", _hoisted_47, [
                    _createElementVNode("ul", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.honors, (honor) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: honor }, null, 8, _hoisted_49))
                      }), 256))
                    ])
                  ]),
                  (_ctx.info.coursework.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_50, " RELEVANT COURSEWORK "))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_51, [
                    _createElementVNode("ul", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.coursework, (course) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: course }, null, 8, _hoisted_53))
                      }), 256))
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}